module.exports = __webpack_public_path__ + "static/media/chocolateBar.5857e1d6.png";